import type { DSCardProps } from "@/src/design_system/layouts_and_containers/card/types";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import { DS_SURFACE } from "@/src/design_system/shared/types/surface";

export const DS_CARD_CLASSES = {
  Root: "ds-card",
  HeaderContainer: "ds-card__header-container",
  Header: "ds-card__header",
  Icon: "ds-card__icon",
  Heading: "ds-card__heading",
  Title: "ds-card__title",
  Subtitle: "ds-card__subtitle",
  Suffix: "ds-card__suffix",
  Actions: "ds-card__actions",
  Toggle: "ds-card__toggle",
  Content: "ds-card__content",
} as const;

export const DS_CARD_SIZE_CLASS: Record<NonNullable<DSCardProps["size"]>, string> = {
  [DS_SIZE.Small]: "ds-card--sm",
  [DS_SIZE.Medium]: "ds-card--md",
  [DS_SIZE.Large]: "ds-card--lg",
} as const;

export const DS_CARD_SURFACE_CLASS: Record<NonNullable<DSCardProps["surface"]>, string> = {
  [DS_SURFACE.Default]: "ds-card--default",
  [DS_SURFACE.Raised]: "ds-card--raised",
  [DS_SURFACE.Accent]: "ds-card--accent",
  [DS_SURFACE.Info]: "ds-card--info",
  [DS_SURFACE.Success]: "ds-card--success",
  [DS_SURFACE.Warning]: "ds-card--warning",
  [DS_SURFACE.Danger]: "ds-card--danger",
} as const;
